export enum BrowserLogType {
  VIEWPORT_SIZE = 'VIEWPORT_SIZE',
}
